import {BoxSize} from "./get-screen-size";


export default function getMainAreaSize():BoxSize {

    const domElement    = document.getElementById('ui-page')

    if (!domElement) {
        // this happens on initial load
        return {
            width   : 600,
            height  : 400
        }
    }

    return {
        width   : domElement.offsetWidth,
        height  : domElement.offsetHeight
    }
}
